<template>
  <div id="brand-logo">
    <a :href="dealer.url.home"><img class="brand-logo" alt="brand logo" width="200" height="200" :class="brand.name" :src="brand.logoImage"></a>
  </div>
</template>

<script>
export default {
  name: 'Logo',
  props: {
    brand: Object,
    dealer: Object
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.brand-logo {
  z-index: 5;
  width: auto;
  height: 30px;
}
.brand-logo.bmw {
  position: relative;
  width: auto;
  height: 30px;
}
.brand-logo.mini {
  position: relative;
}
.brand-logo.jaguar {
  width: 120px;
  height: auto;
  padding-left: 15px;
}
.brand-logo.land-rover {
  height: 50px;
}
.brand-logo.volvo {
  height: 0.6em;
}
.brand-logo.chrysler {
  height: 30px;
}
.brand-logo.dodge {
  height: 18px;
}
.brand-logo.toyota {
  height: 40px;
  max-height: 40px;
}
.brand-logo.audi {
  height: 30px;
}
.brand-logo.chevrolet,
.brand-logo.infiniti {
  height: 45px;
}
.brand-logo.buick {
  height: 30px;
}
.brand-logo.gmc {
  height: 20px;
}
.brand-logo.honda,
.brand-logo.acura,
.brand-logo.mazda,
.brand-logo.kia {
  height: 40px;
}
.brand-logo.lexus {
  height: 35px;
}
.brand-logo.mitsubishi {
  height: 70px;
}
.brand-logo.subaru {
  height: 40px;
}
.brand-logo.ford,
.brand-logo.lincoln {
  height: 40px;
}
.brand-logo.mercedes-benz {
  height: 40px;
}
.brand-logo.nissan {
  height: 60px;
}
.brand-logo.volkswagen {
  height: 50px;
}
.brand-logo.porsche {
  height: 72px;
}

/*small device responsive style*/
@media only screen and (min-width: 576px) {
}
/*medium device responsive style*/
@media only screen and (min-width: 768px) {
  .brand-logo.nissan {
    height: 40px;
  }
}
/*large device responsive style*/
@media only screen and (min-width: 992px) {
  .brand-logo.gmc {
    height: 30px;
  }
  .brand-logo.mazda {
    height: 80px;
  }
  .brand-logo.mitsubishi {
    height: 80px;
  }
}
/*extra large device responsive style*/
@media only screen and (min-width: 1200px) {
  .brand-logo.bmw {
    height: 50px;
  }
  .brand-logo.jaguar {
    width: 150px;
  }
}
</style>
